interface DialogOptions {
    title?: string;
    message: string;
    confirmMessage?: string;
    closeMessage?: string;
}

const isOpen = ref(false);
const dialogOptions = ref<DialogOptions | null>(null);
let resolvePromise: ((value: boolean) => void) | null = null;

export function useDialog() {
    const confirm = (options: DialogOptions): Promise<boolean> => {
        return new Promise((resolve) => {
            // Un SEUL `resolvePromise` pour toute l'app : si une 2e confirmation
            // démarre alors qu'une 1re est en attente, l'ancienne référence était
            // écrasée et sa promesse ne se résolvait JAMAIS. Quand c'est le garde
            // de navigation qui attendait (App.vue `await confirm(...)`), la
            // navigation restait indéfiniment en suspens : la modale disparaît et
            // il ne se passe rien. On solde donc la précédente (annulée) d'abord.
            resolvePromise?.(false);
            isOpen.value = true;
            dialogOptions.value = options;
            resolvePromise = resolve;
        });
    };

    const onConfirm = () => {
        isOpen.value = false;
        const resolve = resolvePromise;
        resolvePromise = null;
        resolve?.(true);
    };

    const onClose = () => {
        isOpen.value = false;
        const resolve = resolvePromise;
        resolvePromise = null;
        resolve?.(false);
    };

    return {
        isOpen,
        dialogOptions,
        confirm,
        onConfirm,
        onClose
    };
}
